(() => {
  const SELECTOR = "[data-charaavi-pcard-slider]";

  function initSlider(root) {
    if (root.dataset.pcardReady === "true") return;
    const track = root.querySelector("[data-pcard-track]");
    const dots = root.querySelectorAll("[data-pcard-dot]");
    if (!track) {
      root.dataset.pcardReady = "true";
      return;
    }

    const slides = track.querySelectorAll(".charaavi-pcard-slider__slide");
    if (slides.length < 2) {
      root.dataset.pcardReady = "true";
      return;
    }

    let active = 0;
    let startX = 0;
    let startY = 0;
    let axis = null;
    let dragging = false;
    let moved = false;
    let startTranslate = 0;

    const slideWidth = () => root.clientWidth || 1;

    const clampIndex = (index) => Math.max(0, Math.min(index, slides.length - 1));

    const translateFor = (index) => -slideWidth() * index;

    const sizeSlides = () => {
      const width = slideWidth();
      slides.forEach((slide) => {
        slide.style.flex = `0 0 ${width}px`;
        slide.style.width = `${width}px`;
        slide.style.maxWidth = `${width}px`;
      });
    };

    const setTranslate = (x, animate) => {
      track.style.transition = animate ? "transform 0.28s ease" : "none";
      track.style.transform = `translate3d(${x}px, 0, 0)`;
    };

    const setActive = (index) => {
      active = clampIndex(index);
      dots.forEach((dot, i) => {
        dot.classList.toggle("is-active", i === active);
      });
    };

    const goTo = (index, animate = true) => {
      sizeSlides();
      setActive(index);
      setTranslate(translateFor(active), animate);
    };

    const onStart = (x, y) => {
      startX = x;
      startY = y;
      axis = null;
      dragging = true;
      moved = false;
      startTranslate = translateFor(active);
      setTranslate(startTranslate, false);
    };

    const onMove = (x, y, event) => {
      if (!dragging) return;
      const dx = x - startX;
      const dy = y - startY;
      const absX = Math.abs(dx);
      const absY = Math.abs(dy);

      if (!axis && (absX > 6 || absY > 6)) {
        axis = absX > absY ? "x" : "y";
      }

      if (axis === "x") {
        moved = true;
        if (event && event.cancelable) event.preventDefault();
        const max = 0;
        const min = translateFor(slides.length - 1);
        let next = startTranslate + dx;
        if (next > max) next = max + (next - max) * 0.2;
        if (next < min) next = min + (next - min) * 0.2;
        setTranslate(next, false);
      } else if (axis === "y") {
        dragging = false;
      }
    };

    const onEnd = (x) => {
      if (axis === "x") {
        const dx = x - startX;
        const threshold = Math.max(36, slideWidth() * 0.18);
        let next = active;
        if (dx < -threshold) next = active + 1;
        else if (dx > threshold) next = active - 1;
        goTo(next, true);
      }
      dragging = false;
      axis = null;
    };

    root.addEventListener(
      "touchstart",
      (event) => {
        const touch = event.touches[0];
        onStart(touch.clientX, touch.clientY);
      },
      { passive: true }
    );

    root.addEventListener(
      "touchmove",
      (event) => {
        const touch = event.touches[0];
        onMove(touch.clientX, touch.clientY, event);
      },
      { passive: false }
    );

    root.addEventListener(
      "touchend",
      (event) => {
        const touch = event.changedTouches[0];
        onEnd(touch ? touch.clientX : startX);
      },
      { passive: true }
    );

    root.addEventListener(
      "touchcancel",
      () => {
        goTo(active, true);
        dragging = false;
        axis = null;
      },
      { passive: true }
    );

    root.addEventListener(
      "click",
      (event) => {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      },
      true
    );

    dots.forEach((dot) => {
      dot.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        goTo(Number(dot.dataset.pcardDot || 0));
      });
    });

    window.addEventListener("resize", () => goTo(active, false), { passive: true });

    goTo(0, false);
    root.dataset.pcardReady = "true";
  }

  function initAll(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll(SELECTOR).forEach(initSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });

  const grid = document.querySelector("[data-product-container]");
  if (grid && "MutationObserver" in window) {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.addedNodes && mutation.addedNodes.length) {
          initAll(grid);
          break;
        }
      }
    });
    observer.observe(grid, { childList: true, subtree: true });
  }
})();
